/* Lymphoria rebuild: behaviour for sections/lymphoria-*.liquid */
document.documentElement.classList.add('js-lym');

const pad = (n) => String(n).padStart(2, '0');
const routes = () => (typeof Theme !== 'undefined' && Theme.routes) ? Theme.routes : {};
const cartAddUrl = () => routes().cart_add_url || '/cart/add.js';
const cartUrl = () => routes().cart_url || '/cart';

/* Countdown to local midnight (sale banner + express line) */
function tick() {
  const now = new Date();
  const end = new Date(now);
  end.setHours(24, 0, 0, 0);
  const ms = Math.max(0, end - now);
  const h = Math.floor(ms / 3600000);
  const m = Math.floor((ms % 3600000) / 60000);
  const s = Math.floor((ms % 60000) / 1000);
  for (const el of document.querySelectorAll('[data-lym-countdown]')) {
    const H = el.querySelector('[data-h]');
    const M = el.querySelector('[data-m]');
    const S = el.querySelector('[data-s]');
    if (H) H.textContent = pad(h);
    if (M) M.textContent = pad(m);
    if (S) S.textContent = pad(s);
  }
  for (const el of document.querySelectorAll('[data-lym-order-within]')) {
    el.textContent = `${h} hrs ${pad(m)} mins`;
  }
}

/* Delivery dates, e.g. "October 17th" */
function ordinal(d) {
  if (d > 3 && d < 21) return `${d}th`;
  return d + ({ 1: 'st', 2: 'nd', 3: 'rd' }[d % 10] || 'th');
}
function initDates(root = document) {
  for (const el of root.querySelectorAll('[data-lym-date]')) {
    const days = Number(el.dataset.days || 3);
    const d = new Date();
    d.setDate(d.getDate() + days);
    el.textContent = `${d.toLocaleString('en-US', { month: 'long' })} ${ordinal(d.getDate())}`;
  }
}

/* Gallery */
function initGallery(root = document) {
  for (const gal of root.querySelectorAll('[data-lym-gallery]')) {
    if (gal.dataset.lymInit) continue;
    gal.dataset.lymInit = '1';
    const track = gal.querySelector('[data-lym-track]');
    const thumbs = [...gal.querySelectorAll('[data-lym-thumb]')];
    if (!track) continue;
    const setActive = (i) => thumbs.forEach((t, n) => {
      t.classList.toggle('is-active', n === i);
      t.setAttribute('aria-current', n === i ? 'true' : 'false');
    });
    thumbs.forEach((t, i) => t.addEventListener('click', () => {
      const slide = track.children[i];
      if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      setActive(i);
    }));
    let raf = 0;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => setActive(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))));
    }, { passive: true });
    setActive(0);
  }
}

/* Bundle / buy forms */
function planPrices(form) {
  if (!form._lymPlanPrices) {
    try {
      form._lymPlanPrices = JSON.parse(form.querySelector('[data-lym-plan-prices]')?.textContent || '{}');
    } catch (_) {
      form._lymPlanPrices = {};
    }
  }
  return form._lymPlanPrices;
}

function updateForm(form) {
  const radio = form.querySelector('input[name="id"]:checked');
  for (const card of form.querySelectorAll('.lym-bundle')) {
    card.classList.toggle('is-selected', !!radio && card.contains(radio));
  }
  const planRadio = form.querySelector('input[data-lym-plan-radio]');
  const onceRadio = form.querySelector('input[data-lym-once-radio]');
  const planSelect = form.querySelector('select[data-lym-plan-select]');
  let subPrice = '';
  if (planRadio) {
    if (planSelect && planSelect.value) planRadio.value = planSelect.value;
    const map = planPrices(form);
    subPrice = (radio && map[radio.value] && map[radio.value][planRadio.value]) || '';
    planRadio.disabled = !subPrice;
    if (!subPrice && planRadio.checked && onceRadio) onceRadio.checked = true;
  }
  const subscribe = !!planRadio && planRadio.checked && !planRadio.disabled;
  form.dataset.mode = subscribe ? 'subscribe' : 'once';
  for (const card of form.querySelectorAll('.lym-plan')) {
    const input = card.querySelector('input[type="radio"]');
    card.classList.toggle('is-selected', !!input && input.checked);
    card.classList.toggle('is-disabled', !!input && input.disabled);
  }
  const price = subscribe ? subPrice : (radio ? radio.dataset.price : '');
  for (const el of form.querySelectorAll('[data-lym-atc-price]')) el.textContent = price;
}

async function addToCart(form) {
  const btn = form.querySelector('[type="submit"]');
  const errorEl = form.querySelector('[data-lym-error]');
  const fd = new FormData(form);
  const id = fd.get('id');
  if (!id) return;
  const quantity = Number(fd.get('quantity') || 1);
  const item = { id: Number(id), quantity };
  const plan = form.dataset.mode === 'subscribe' ? fd.get('selling_plan') : '';
  if (plan) item.selling_plan = Number(plan);
  const sections = [...document.querySelectorAll('cart-items-component')]
    .map((c) => c.dataset.sectionId)
    .filter(Boolean);

  if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
  if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }

  let events = null;
  try { events = await import('@shopify/events'); } catch (_) { events = null; }
  const deferred = events && events.CartLinesUpdateEvent && events.CartLinesUpdateEvent.createPromise
    ? events.CartLinesUpdateEvent.createPromise()
    : null;
  if (deferred) {
    form.dispatchEvent(new events.CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: String(id), quantity }],
      promise: deferred.promise,
    }));
  }

  try {
    const res = await fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item], sections: sections.join(',') }),
    });
    const data = await res.json();
    const cart = await fetch(`${cartUrl()}.js`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then((r) => r.json());
    if (data.status) {
      const msg = data.description || data.message || 'Something went wrong.';
      if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; }
      if (deferred) {
        deferred.resolve({
          cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { didError: true, items: cart.items, source: 'lymphoria-buy-form', itemCount: quantity, productId: form.dataset.productId },
        });
        if (events.CartErrorEvent) form.dispatchEvent(new events.CartErrorEvent({ error: msg, code: 'INVALID' }));
      }
      return;
    }
    if (deferred) {
      deferred.resolve({
        cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          source: 'lymphoria-buy-form',
          sourceId: form.id,
          itemCount: quantity,
          productId: form.dataset.productId,
          sections: data.sections,
          didError: false,
        },
      });
    } else {
      window.location.href = cartUrl();
    }
  } catch (err) {
    if (deferred) deferred.reject(err);
    form.submit();
  } finally {
    if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
  }
}

function initForms(root = document) {
  for (const form of root.querySelectorAll('form[data-lym-form]')) {
    if (form.dataset.lymInit) continue;
    form.dataset.lymInit = '1';
    form.addEventListener('change', () => updateForm(form));
    form.addEventListener('submit', (e) => { e.preventDefault(); addToCart(form); });
    updateForm(form);
  }
}

/* Dialogs */
document.addEventListener('click', (e) => {
  const opener = e.target.closest('[data-lym-open]');
  if (opener) {
    const dlg = document.getElementById(opener.dataset.lymOpen);
    if (dlg && typeof dlg.showModal === 'function') { e.preventDefault(); dlg.showModal(); }
    return;
  }
  const closer = e.target.closest('[data-lym-close]');
  if (closer) { closer.closest('dialog')?.close(); return; }
  if (e.target instanceof HTMLDialogElement && e.target.classList.contains('lym-dialog')) e.target.close();
});

/* Tabs */
function initTabs(root = document) {
  for (const tabs of root.querySelectorAll('[data-lym-tabs]')) {
    if (tabs.dataset.lymInit) continue;
    tabs.dataset.lymInit = '1';
    const buttons = [...tabs.querySelectorAll('[role="tab"]')];
    const select = (btn) => {
      for (const b of buttons) {
        const on = b === btn;
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(b.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      }
    };
    buttons.forEach((b, i) => {
      b.addEventListener('click', () => select(b));
      b.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        const next = buttons[(i + (e.key === 'ArrowRight' ? 1 : buttons.length - 1)) % buttons.length];
        next.focus();
        select(next);
      });
    });
  }
}

/* Sticky bars. trigger "buy": after the first buy box was scrolled past; "hero": after the hero left the screen.
   Hidden while any buy box is on screen. */
function initSticky() {
  const anchors = [...document.querySelectorAll('[data-lym-buy-anchor]')];
  for (const bar of document.querySelectorAll('[data-lym-sticky]')) {
    if (bar.dataset.lymInit) continue;
    const trigger = bar.dataset.trigger === 'hero' ? document.querySelector('[data-lym-hero-anchor]') : anchors[0];
    if (!trigger) continue;
    bar.dataset.lymInit = '1';
    const state = new Map();
    const io = new IntersectionObserver((entries) => {
      for (const en of entries) state.set(en.target, { visible: en.isIntersecting, above: en.boundingClientRect.top < 0 });
      const t = state.get(trigger);
      const buyVisible = anchors.some((a) => state.get(a)?.visible);
      bar.classList.toggle('is-visible', !!t && !t.visible && t.above && !buyVisible);
    });
    io.observe(trigger);
    anchors.forEach((a) => { if (a !== trigger) io.observe(a); });
  }
}

/* Contact steps */
function initContact(root = document) {
  for (const form of root.querySelectorAll('[data-lym-contact]')) {
    if (form.dataset.lymInit) continue;
    form.dataset.lymInit = '1';
    const steps = [...form.querySelectorAll('[data-lym-step]')];
    const nav = [...form.querySelectorAll('[data-lym-step-nav]')];
    const review = form.querySelector('[data-lym-review-summary]');
    let current = 0;
    const show = (i) => {
      current = i;
      steps.forEach((s, n) => { s.hidden = n !== i; });
      nav.forEach((n, k) => { n.classList.toggle('is-active', k === i); n.classList.toggle('is-done', k < i); });
      if (review && i === steps.length - 1) {
        const data = new FormData(form);
        const lines = [];
        for (const [k, v] of data.entries()) {
          if (!k.startsWith('contact[') || !String(v).trim()) continue;
          lines.push(`${k.slice(8, -1)}: ${v}`);
        }
        review.textContent = lines.join('\n');
      }
    };
    form.addEventListener('click', (e) => {
      const next = e.target.closest('[data-lym-next]');
      const prev = e.target.closest('[data-lym-prev]');
      if (next) {
        const fields = [...steps[current].querySelectorAll('input, textarea, select')];
        const invalid = fields.find((f) => !f.checkValidity());
        if (invalid) { invalid.reportValidity(); return; }
        show(Math.min(current + 1, steps.length - 1));
      }
      if (prev) show(Math.max(current - 1, 0));
    });
    if (steps.length) show(0);
  }
}

function initAll(root = document) {
  initDates(root);
  initGallery(root);
  initForms(root);
  initTabs(root);
  initContact(root);
  initSticky();
}

tick();
setInterval(tick, 1000);
initAll();
document.addEventListener('shopify:section:load', (e) => initAll(e.target));
